"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _conductor = require("@virtuous/conductor");

var _ = _interopRequireDefault(require("../404"));

var _context = require("../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The Route component.
 */
var Route =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Route, _React$Component);

  /**
   * @param {Object} props The component props.
   */
  function Route(props) {
    var _this;

    _classCallCheck(this, Route);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Route).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getContextValue", function () {
      var _router$getCurrentRou = _conductor.router.getCurrentRoute(),
          context = _extends({}, _router$getCurrentRou);

      context.open = true;
      context.visible = true;
      return context;
    });

    _conductor.router.register(props.pattern, props.transform);

    return _this;
  }
  /**
   * @returns {Object}
   */


  _createClass(Route, [{
    key: "render",

    /**
     * @returns {JSX}
     */
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.component,
          pattern = _this$props.pattern;

      var route = _conductor.router.getCurrentRoute();

      if (route.pattern !== pattern) {
        return null;
      }

      var transform = route.transform,
          props = _objectWithoutProperties(route, ["transform"]);

      var key = "".concat(route.id, "-").concat(route.pathname);
      return _react["default"].createElement(_context.RouteContext.Provider, {
        key: key,
        value: this.getContextValue()
      }, _react["default"].createElement(Component, {
        route: props
      }));
    }
  }]);

  return Route;
}(_react["default"].Component);

_defineProperty(Route, "contextType", _context.RouterContext);

_defineProperty(Route, "NotFound", _["default"]);

_defineProperty(Route, "defaultProps", {
  transform: null
});

var _default = Route;
exports["default"] = _default;